import styles from './AboutMe.module.scss'
import { motion } from "framer-motion"
import image from '../../image/AboutMe/img_1.jpg'

const imageAnimation = {
    hidden: {
        scale: 0,
        opacity: 0,
    },

    visible: {
        scale: 1,
        opacity: 1,
        transition: { duration: .5 }
    }
}

const textAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },

    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .5 }
    }
}

const AboutMe = () => {

    return (
        <motion.section 
        className={styles.main}
        id='o-nas' 
        initial='hidden'
        whileInView='visible'
        viewport={{amount: 0.05, once: true}}
        >
            <div className={styles.container}>
                <motion.img className={styles.image} src={image} alt='человек' variants={imageAnimation}/>
                <div className={styles.info}>
                    <motion.h2 
                        className={styles.title} 
                        variants={textAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        
                        >О пакетах <span>МусорКИНЬ</span></motion.h2>
                    <motion.p 
                        className={styles.text} 
                        variants={textAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.001, once: true}}
                        >Мусорные пакеты под ТМ МусорКИНЬ, разработаны на основе анализа рынка мусорных пакетов за последние 20 лет. Специалистами  которые имеют огромный и уникальный опыт а так же  и практические знания как в производстве так и в продажах  мусорных пакетов. Постоянно отслеживают современные тенденции в области переработки полимеров . На основе этих знаний и опыта они выводят на рынок пакеты МусорКИНЬ.</motion.p>    
                    <motion.p 
                        className={styles.text} 
                        variants={textAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.001, once: true}}
                        >Пакеты МусорКИНЬ изготовлены с использованием вторичного полиэтилена и благодаря самому современному оборудованию, опытным высококлассным специалистам и уникальным технологиям производства и переработки достигают высокого уровня потребительских свойств. А по качеству практически аналогичны пакетам из первичного полиэтилена т.е. отсутствуют все признаки вторичного полиэтилена такие как резкий запах, “шероховатость полотна”, разнотолщинность. </motion.p>
                        <motion.p 
                        className={styles.text} 
                        variants={textAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.001, once: true}}
                        >Пакеты под ТМ МусорКИНЬ представлены в размерах от 30 литров до 360 литров и толщиной от 20 мкм и до 100 мкм что позволяет их использовать для различных нужд и потребностей.
                        </motion.p>
                        <motion.p 
                        className={styles.text} 
                        variants={textAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.001, once: true}}
                        >Линейка мусорных пакетов ТМ МусорКИНЬ имеют оптимальное соотношение ЦЕНА-КАЧЕСТВО и практически полностью покрывают потребности рынка, каждый покупатель сможет подобрать продукцию для себя. Если он не сможет это сделать то готовы разработать  и изготовить пакеты по индивидуальным параметрам.
                        </motion.p>
                </div>
            </div>   
    </motion.section>
    )
}

export default AboutMe